import {
    type DigitallyReceivedPrescriberOrderBasicInfoFragment,
    type DigitallyReceivedPrescriberOrderInfoFragment,
    PrescriberOrderStatus,
    type UnclaimedPrescriberOrderInfoFragment,
} from '../../graphql/generated/graphql';

// Reserved for future integration with UnclaimedPrescriberOrders
// Omit fragment name so PrescriberOrderFragment *can* be assigned to a basic fragment component
export type BasicPrescriberOrderFragment =
    | Omit<DigitallyReceivedPrescriberOrderBasicInfoFragment, ' $fragmentName'>
    | Omit<UnclaimedPrescriberOrderInfoFragment, ' $fragmentName'>;

export const isRoutable = (
    order:
        | DigitallyReceivedPrescriberOrderInfoFragment
        | UnclaimedPrescriberOrderInfoFragment
) => {
    if (order.__typename !== 'DigitallyReceivedPrescriberOrder') {
        return false;
    }

    return (
        order.status === PrescriberOrderStatus.New ||
        order.status === PrescriberOrderStatus.OnHold ||
        order.status === PrescriberOrderStatus.Pending
    );
};
